<template>
  <div>
    <v-toolbar tabs :style="{
      zIndex: 1,
      borderTop: '1px solid',
      borderBottom: '1px solid',
      borderColor: '#ccc',
    }" height="128" card color="#fff">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link :to="props.item.href" :is="props.item.disabled ? 'span' : 'router-link'">
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <div class="mr-3" :style="{
            padding: '8px',
            display: 'inline-block',
            backgroundColor: '#ef565c',
            borderRadius: '0.5rem',
          }">
            <v-icon medium color="#fff">edit_square</v-icon>
          </div>
          <h1 style="display: inline">Editar horario</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-card flat class="border-container" style="min-height: 400px">
              <v-card-text>
                <div v-if="type == 'FULL_TIME'">
                  <FullTimeForm ref="fullTimeForm" @onSubmit="onSubmit" @onCancel="onCancel"
                    @onDeleteSelected="onDeleteSelected" :initial-values="initialValues" :selected="selectedForm"
                    on-cancel-alert-msg="¿Estas seguro que deseas cancelar la edición del horario? Esta acción eliminará definitivamente los datos ingresados." />
                </div>
                <div v-if="type == 'HOURS_BY_DAY'">
                  <HoursByDayForm ref="hoursByDayForm" @onSubmit="onSubmit" @onCancel="onCancel"
                    @onDeleteSelected="onDeleteSelected" :initial-values="initialValues" :selected="selectedForm"
                    on-cancel-alert-msg="¿Estas seguro que deseas cancelar la edición del horario? Esta acción eliminará definitivamente los datos ingresados." />
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card flat class="border-container">
              <v-card-text>
                <CollaboradorsTable @onSelect="onSelectCollaborators" @onError="onError" :selectedProp="selectedForm"
                  :extraItems="extraItems" :idSchedule="$router.history.current.params.id" />
              </v-card-text>
            </v-card>
            <v-layout justify-end row class="py-3">
              <v-btn @click="confirmCancel" :disabled="feedback.saving">Cancelar</v-btn>
              <v-btn @click="emmitSubmit" :disabled="feedback.saving" color="#ef565c" style="color: #fff"> Guardar
              </v-btn>
            </v-layout>
          </v-flex>

          <loading v-model="feedback.working" text="Trabajando..." />
          <error v-model="feedback.failed" :text="feedback.failMsg" />
          <UpdateConfirm :value="requestConfirmation" @desition="desition" />
          <UpdateSuccess :value="feedback.success" />
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import CollaboradorsTable from "./CollaboratorsTable.vue";
import FullTimeForm from "./FullTime.vue";
import HoursByDayForm from "./HoursByDay.vue";
import loading from "../../Dialogs/Loading.vue";
import error from "../../Dialogs/Error.vue";
import UpdateConfirm from "./UpdateConfirm.vue";
import UpdateSuccess from "./UpdateSuccess.vue";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  components: {
    UpdateConfirm,
    UpdateSuccess,
    CollaboradorsTable,
    FullTimeForm,
    HoursByDayForm,
    loading,
    error,
  },
  data: () => ({
    feedback: {
      success: false,
      failed: false,
      working: false,
      saving: false,
      failMsg: 'Error'
    },
    requestConfirmation: false,
    confirmed: false,
    formValues: null,
    type: "",
    initialValues: null,
    initialValuesFormComparation: null,
    breadcrumbs: [
      {
        text: "Horarios",
        disabled: false,
        href: "/es/panel/checker",
      },
      {
        text: "Editar horario",
        disabled: true,
        href: "/es/panel/checker/update",
      },
    ],
    selectedForm: [],
    extraItems: [],
  }),
  methods: {
    onError(error) {
      console.log(error)
      this.feedback.failMsg = 'No tienes permisos para realizar esta acción';
      this.feedback.failed = true;
    },
    somethingChangeOnFormValues(initialObj, newObj) {

      const initObject = Object.entries(initialObj)
      const newObject = Object.entries(newObj)
      let somethingChanged = false

      for (let i = 0; i < initObject.length; i++) {
        const [key, val] = initObject[i]
        const [, newVal] = newObject[i]


        if (key == 'collaboratorIds') {
          const ss1 = val.reduce((acc, el) => ([...acc, el.id]), []).sort((a, b) => a - b).toString()
          const ss2 = newVal.reduce((acc, el) => ([...acc, el.id]), []).sort((a, b) => a - b).toString()
          if (ss1 !== ss2) {
            somethingChanged = true
            break
          }
        } else if (key == 'scheduleDays') {
          const ss1 = val.sort((a, b) => a.dayOfWeek - b.dayOfWeek).map((e) => Object.values(e)).flat().toString()
          const ss2 = newVal.sort((a, b) => a.dayOfWeek - b.dayOfWeek).map((e) => Object.values(e)).flat().toString()

          if (ss1 !== ss2) {
            somethingChanged = true
            break
          }
        } else {
          if (val !== newVal) {
            somethingChanged = true
            break
          }
        }
      }
      return somethingChanged
    },
    confirmCancel() {
      const isOkShowModal = this.somethingChangeOnFormValues(this.initialValuesFormComparation, this.initialValues)

      if (!isOkShowModal) {
        this.onCancel()
        return;
      }

      if (this.type === "FULL_TIME")
        this.$refs.fullTimeForm.openCancelModal();
      else
        this.$refs.hoursByDayForm.openCancelModal();
    },
    emmitSubmit() {
      if (this.type === "FULL_TIME")
        this.$refs.fullTimeForm.submit();
      else
        this.$refs.hoursByDayForm.submit();
    },
    desition(v) {
      this.confirmed = v;
      this.requestConfirmation = !this.requestConfirmation;
      if (v) {
        this.onSubmit(this.formValues);
      }
    },
    onDeleteSelected(c) {
      const { selectedForm } = this;
      this.selectedForm = selectedForm.filter((i) => {
        return i.id != c.id;
      });
    },
    onSelectCollaborators(collaborators) {
      this.selectedForm = collaborators;
    },
    onCancel() {
      this.$router.push({
        name: "checker",
      });
    },
    onSubmit(values) {
      this.feedback.saving = true;
      if (!this.confirmed) {
        this.requestConfirmation = true;
        this.formValues = values;
        this.feedback.saving = false;
        return;
      }
      this.feedback.working = true;
      return this.$store
        .dispatch("checker/editSchedule", {
          idSchedule: this.$router.history.current.params.id,
          data: values,
        })
        .then(res => {

          if (res.data && res.data.code === 1017) {
            this.onError(res.data);
            this.loading = false;
          }
          else {
            this.feedback.success = true;
          }

          setTimeout(() => {
            this.$router.push({
              name: "checker",
            });
          }, 3000);

        })
        .catch(e => {
          console.log(e)
          this.feedback.failMsg = 'Ocurrió un error';
          this.feedback.failed = true;
          this.feedback.saving = false;
          setTimeout(() => {
            this.feedback.failed = false;
          }, 3000);
        })
        .finally(() =>
          this.feedback.working = false
        );
    },
    retrieveSchedule(id) {
      this.$store
        .dispatch("checker/retrieveSchedule", id)
        .then(({ data }) => {
          const transform2Digits = (num) =>
            num.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            });

          if (data.type == "FULL_TIME") {
            this.initialValues = {
              collaboratorIds: data.collaborators,
              type: "FULL_TIME",
              name: data.name,
              startTime: moment(data.startTime, "HH:mm:ss").format("hh:mm a"),
              endTime: moment(data.endTime, "HH:mm:ss").format("hh:mm a"),
              minutesEarly:
                transform2Digits(Math.floor(data.minutesEarly / 60)) +
                ":" +
                transform2Digits(data.minutesEarly % 60),
              minutesLate:
                transform2Digits(Math.floor(data.minutesLate / 60)) +
                ":" +
                transform2Digits(data.minutesLate % 60),
            };
            this.initialValuesFormComparation = JSON.parse(JSON.stringify(this.initialValues))
          }

          if (data.type == "HOURS_BY_DAY") {
            const restDays = ((this.getBranch && this.getBranch.ableDays) || [])
              .filter((d) => {
                return !data.scheduleDays.some((s) => s.dayOfWeek == d.id);
              })
              .map((i) => ({
                dayOfWeek: i.id,
                startTime: "",
                endTime: "",
                enabled: true,
              }));

            this.initialValues = {
              collaboratorIds: data.collaborators,
              type: "HOURS_BY_DAY",
              name: data.name,
              minutesEarly:
                transform2Digits(Math.floor(data.minutesEarly / 60)) +
                ":" +
                transform2Digits(data.minutesEarly % 60),
              minutesLate:
                transform2Digits(Math.floor(data.minutesLate / 60)) +
                ":" +
                transform2Digits(data.minutesLate % 60),
              scheduleDays: [
                // los dias que tiene guardado el horario
                ...data.scheduleDays.map((i) => ({
                  ...i,
                  startTime: moment(i.startTime, "HH:mm:ss").format("hh:mm a"),
                  endTime: moment(i.endTime, "HH:mm:ss").format("hh:mm a"),
                  enabled: true,
                })),
                // los dias que tiene habilitado el colegio con lalores vacios
                ...restDays,
              ].sort((a, b) => {
                return a.dayOfWeek - b.dayOfWeek;
              }),
            };
            this.initialValuesFormComparation = JSON.parse(JSON.stringify(this.initialValues))

          }
          this.type = data.type;
          this.selectedForm = [...data.collaborators];
          this.extraItems = [...data.collaborators];
        })
        .catch();
    },
  },
  mounted() {
    this.retrieveSchedule(this.$router.history.current.params.id);
  },
  computed: {
    ...mapGetters(["getBranch"]),
  },
};
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}

.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
</style>